const download = require("downloadjs");
import sysFolderTree from '../../components/sys-folder-tree/index.vue';
export default {
    data() {
        return {
            baseUrl: this.$global.baseUrl,
            folderPaths: [{
                id: "",
                name: "资料库",
                parentId: ""
            }],
            uploadLimit: 10,
            folderList: [],
            fileList: [],
            uploadFileList: [],
            searchContent: "",
            dialogManageShow: false,
            manageForm: {},
            dialogFolderChooseVisible: false
        }
    },
    components: { sysFolderTree },
    mounted: function () {
        this.query();
    },
    methods: {

        /**
         * 点击事件
         * @param {*} id 
         */
        clickEvent: function (id, data) {
            switch (id) {
                case "esc": //点击返回
                    if (this.folderPaths.length == 1) {
                        this.$message.closeAll();
                        this.$message.warning("已经是首页了");
                        return;
                    }
                    this.folderPaths.pop();
                    this.query();
                    break;
                case "refresh": //刷新
                    this.query();
                    break;
                case "add": //新增
                    this.manageForm = { parentId: this.folderPaths[this.folderPaths.length - 1].id, isFile: false };
                    this.dialogManageShow = true;
                    break;
                case "edit": //修改
                    var folderCheckedCount = 0;
                    var folderCheckedObj;
                    this.folderList.forEach(elem => {
                        folderCheckedCount += elem.checked ? 1 : 0;
                        if (elem.checked)
                            folderCheckedObj = Object.assign({}, elem);
                    });
                    var fileCheckedCount = 0;
                    var fileCheckedObj;
                    this.fileList.forEach(elem => {
                        fileCheckedCount += elem.checked ? 1 : 0;
                        if (elem.checked)
                            fileCheckedObj = Object.assign({}, elem);
                    });
                    if (folderCheckedCount + fileCheckedCount != 1) {
                        this.$message.closeAll();
                        this.$message.warning("请选择一项进行操作");
                        return;
                    }
                    this.manageForm = folderCheckedCount == 1 ? folderCheckedObj : fileCheckedObj;
                    this.manageForm.isFile = fileCheckedCount == 1;
                    this.dialogManageShow = true;
                    break;
                case "delete": //删除
                    var folderCheckedIds = new Array;
                    this.folderList.forEach(elem => {
                        if (elem.checked)
                            folderCheckedIds.push(elem.id);
                    });
                    var fileCheckedIds = new Array;
                    this.fileList.forEach(elem => {
                        if (elem.checked)
                            fileCheckedIds.push(elem.id);
                    });
                    if (folderCheckedIds.length + fileCheckedIds.length == 0) {
                        this.$message.closeAll();
                        this.$message.warning("请选择至少一项进行操作");
                        return;
                    }
                    this.$confirm('此操作将删除所选中的文件, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.delete(folderCheckedIds, fileCheckedIds);
                    }).catch(() => { });
                    break;
                case "manageConfirm": //确定
                    this.$refs['manageForm'].validate((valid) => {
                        if (valid) {
                            if (this.manageForm.isFile) {
                                var fileSuffix = this.manageForm.suffix;
                                //获取新文件名后缀
                                var newFileNameSuffix = this.manageForm.name.split('.').pop().toLowerCase();
                                if (fileSuffix != newFileNameSuffix) {
                                    this.$message.closeAll();
                                    this.$message.warning("文件格式与原文件不一致，无法重命名");
                                    return;
                                }
                                this.updateFile();
                            } else {
                                this.saveOrUpdate();
                            }
                        } else {
                            return false;
                        }
                    });
                    break;
                case "download": //下载
                    download(this.$global.baseUrl + data.path);
                    break;
                case "move": //移动
                    var folderCheckedCount = 0;
                    var folderCheckedObj;
                    this.folderList.forEach(elem => {
                        folderCheckedCount += elem.checked ? 1 : 0;
                        if (elem.checked)
                            folderCheckedObj = Object.assign({}, elem);
                    });
                    var fileCheckedCount = 0;
                    var fileCheckedObj;
                    this.fileList.forEach(elem => {
                        fileCheckedCount += elem.checked ? 1 : 0;
                        if (elem.checked)
                            fileCheckedObj = Object.assign({}, elem);
                    });
                    if (folderCheckedCount + fileCheckedCount != 1) {
                        this.$message.closeAll();
                        this.$message.warning("请选择一项进行操作");
                        return;
                    }
                    this.manageForm = folderCheckedCount == 1 ? folderCheckedObj : fileCheckedObj;
                    this.manageForm.isFile = fileCheckedCount == 1;
                    this.dialogFolderChooseVisible = true;
                    break;
                case "folderPath"://点击面包屑路径
                    if (data.id == this.folderPaths[this.folderPaths.length - 1].id) return;
                    for (var i = 0; i < this.folderPaths.length; i++) {
                        if (this.folderPaths[i].id == data.id) {
                            this.folderPaths.splice(i + 1);
                            break;
                        }
                    }
                    this.query();
                    break;
                default:
                    break;
            }
        },

        /**
         * 双击事件
         * @param {*} id 
         * @param {*} data 
         */
        dbClickEvent: function (id, data) {
            switch (id) {
                case "folder": //文件夹
                    this.folderPaths.push(data);
                    this.query();
                    break;
                case "file": //文件
                    if (data.fileType == 1 || data.fileType == 2 || data.fileType == 3 || data.fileType == 4)
                        window.open(this.baseUrl + data.path, "_blank");
                    break;
            }
        },

        /**
         * 上传失败
         * @param {*} files 
         * @param {*} fileList 
         */
        handleError: function (err, file, fileList) {
            this.$message.closeAll();
            this.$message.error("上传失败");
        },

        handleExceed(files, fileList) {
            this.$message.warning("已超出文件选择数量，单次限制上传" + this.uploadLimit + "个文件");
        },

        /**
         * 上传成功
         * @param {*} response 
         * @param {*} file 
         * @param {*} fileList 
         */
        handleSuccess: function (response, file, fileList) {
            this.uploadFileList = [];
            if (response.success) {
                setTimeout(() => {
                    this.$message.closeAll();
                    this.$message.success("上传成功");
                    this.query();
                }, 300);
            } else {
                this.$message.closeAll();
                this.$message.error(response.message);
            }
        },

        /**
         * 格式化日期
         * @param {*} date 
         */
        formatDate: function (date) {
            if (date == null)
                return "-";
            if (date.length <= 10)
                return date.substring(0, date.length);
            return date.substring(0, 10);
        },

        /**
         * 获取文件类型图标
         * @param {*} item 
         */
        getFileIconType: function (item) {
            switch (item.fileType) {
                case 2: //视频
                    return require("../../../static/images/ic_file_video.png");
                case 3: //音频
                    return require("../../../static/images/ic_file_audio.png");
                case 4: //office
                    var suffix = item.suffix.toLowerCase();
                    if (suffix == "doc" || suffix == "docx")
                        return require("../../../static/images/ic_file_word.png");
                    else if (suffix == "xlsx" || suffix == "xls")
                        return require("../../../static/images/ic_file_excel.png");
                    else if (suffix == "ppt" || suffix == "pptx")
                        return require("../../../static/images/ic_file_ppt.png");
                    else if (suffix == "txt")
                        return require("../../../static/images/ic_file_txt.png");
                    else if (suffix == "pdf")
                        return require("../../../static/images/ic_file_pdf.png");
                    else
                        return require("../../../static/images/ic_file_default.png");
                default:
                    return require("../../../static/images/ic_file_default.png");
            }
        },

        /**
         * 输入变化
         * @param {*} e 
         */
        onSearchChange: function (val) {
            this.query();
        },

        /**
         * 文件夹选择回调
         * @param {*} folder 
         */
        onFolderChooseCallback: function (folder) {
            this.dialogFolderChooseVisible = false;
            if (this.manageForm.isFile) {//修改文件路径
                this.manageForm.folderId = folder.id;
                this.updateFile();
            } else {//修改文件夹路径
                this.manageForm.parentId = folder.id;
                this.saveOrUpdate();
            }
        },

        /**
         * 关闭文件夹选择弹窗
         * @param {*} flag 
         */
        onDialogFolderChooseClose: function (flag) {
            this.dialogFolderChooseVisible = flag;
        },

        /**
         * 新增或删除
         */
        saveOrUpdate: function () {
            this.$post({
                url: "/folder/saveOrUpdate",
                params: {
                    id: this.manageForm.id,
                    name: this.manageForm.name,
                    parentId: this.manageForm.parentId
                }
            }).then(res => {
                this.manageForm = {};
                this.dialogManageShow = false;
                this.$message.closeAll();
                this.$message.success("操作成功");
                this.query();
            });
        },

        /**
         * 重命名文件
         */
        updateFile: function () {
            this.$post({
                url: "/file/update",
                params: {
                    id: this.manageForm.id,
                    name: this.manageForm.name,
                    folderId: this.manageForm.folderId
                }
            }).then(res => {
                this.manageForm = {};
                this.dialogManageShow = false;
                this.$message.closeAll();
                this.$message.success("操作成功");
                this.query();
            });
        },

        /**
         * 批量删除
         */
        delete: function (folderCheckedIds, fileCheckedIds) {
            if (folderCheckedIds.length > 0) {
                this.$post({
                    url: "/folder/delete",
                    params: {
                        ids: folderCheckedIds
                    }
                }).then(res => {
                    if (fileCheckedIds.length > 0) {
                        this.$post({
                            url: "/file/delete",
                            params: {
                                ids: fileCheckedIds
                            }
                        }).then(res => {
                            this.$message.closeAll();
                            this.$message.success("删除成功");
                            this.query();
                        });
                    } else {
                        this.$message.closeAll();
                        this.$message.success("删除成功");
                        this.query();
                    }
                });
            } else {
                this.$post({
                    url: "/file/delete",
                    params: {
                        ids: fileCheckedIds
                    }
                }).then(res => {
                    this.$message.closeAll();
                    this.$message.success("删除成功");
                    this.query();
                });
            }
        },

        /**
         * 修改
         */
        edit: function () {
            this.$post({
                url: "/contractorType/edit",
                params: {
                    id: this.manageForm.id,
                    name: this.manageForm.name,
                    description: this.manageForm.description
                }
            }).then(res => {
                this.manageForm = {};
                this.dialogManageShow = false;
                this.$message.closeAll();
                this.$message.success("修改成功");
                this.query();
            });
        },

        /**
         * 查询
         */
        query: function () {
            //查文件夹列表
            this.$post({
                url: 'folder/query',
                params: {
                    parentId: this.folderPaths[this.folderPaths.length - 1].id,
                    keyWord: this.searchContent
                }
            }, true).then(data => {
                data.forEach(elem => {
                    elem.checked = false;
                });
                this.folderList = data;
            });
            //查文件列表
            this.$post({
                url: 'file/findByFolderFile',
                params: {
                    folderId: this.folderPaths[this.folderPaths.length - 1].id,
                    keyWord: this.searchContent
                }
            }, true).then(data => {
                data.forEach(elem => {
                    elem.checked = false;
                });
                this.fileList = data;
            });
        }
    }
}